import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LcsDateRangePickerInputPanelContentFormValue } from '@lcs/shared/datepicker';
import { Subject } from 'rxjs';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';
import {
   DateRangeSelectParameterFormModel,
   DateRangeSelectReportParameterValue,
} from '../models/date-range-report-parameter-value';
import { ReportParameterConfig } from '../report-parameter-list/report-parameter.config';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-date-range-select-report-parameter',
    styleUrls: ['./date-range-select-report-parameter.component.scss'],
    templateUrl: './date-range-select-report-parameter.component.html',
    standalone: false
})
export class DateRangeSelectReportParameterComponent implements OnDestroy {
   config: ReportParameterConfig;

   contentFormValue: LcsDateRangePickerInputPanelContentFormValue<Date>;

   dateRangeFields: string[] = ['Start Date', 'Due Date'];

   // dateRangePickerOptions = dateRangePickerOptions(new LcsNativeDateAdapter(this.dateAdapter));

   set form(form: UntypedFormGroup) {
      this._form = form;
      const formValue: DateRangeSelectParameterFormModel = this.form.value;
      this.initializeContentFormValue();
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   get label() {
      return this.config?.label;
   }

   private _form: UntypedFormGroup;

   constructor(private formBuilder: UntypedFormBuilder, private dateAdapter: LcsDateTimeAdapter<Date>) {}

   private destroyed$ = new Subject<void>();

   ngOnDestroy(): void {
      // QMG-3199 - Once updated to angular v12+ we can remove this code to handle cleaning up form controls
      // https://github.com/angular/angular/issues/27803
      const formValue: DateRangeSelectParameterFormModel = this.form.value;

      this.form.removeControl('startDate');
      this.form.removeControl('endDate');
      this.form.removeControl('filterByDateRange');
      this.form.removeControl('field');

      const dateRangeReportParameterValue: DateRangeSelectReportParameterValue = {
         endDate: formValue.endDate,
         field: formValue.field,
         filterByDateRange: formValue.filterByDateRange,
         startDate: formValue.startDate,
      };

      const startDate: UntypedFormControl = this.formBuilder.control(dateRangeReportParameterValue.startDate);
      const endDate: UntypedFormControl = this.formBuilder.control(dateRangeReportParameterValue.endDate);
      const field: UntypedFormControl = this.formBuilder.control(dateRangeReportParameterValue.field);
      const filterByDateRange: UntypedFormControl = this.formBuilder.control(dateRangeReportParameterValue.filterByDateRange);

      this.form.addControl('startDate', startDate);
      this.form.addControl('endDate', endDate);
      this.form.addControl('filterByDateRange', filterByDateRange);
      this.form.addControl('field', field);
      // -------------------------------------------------------------------------------------------------
      this.destroyed$.next();
   }

   onContentFormValueChange(contentFormValue: LcsDateRangePickerInputPanelContentFormValue<Date>): void {
      this.form.patchValue({
         relativeDate: contentFormValue.datePickerOption?.id ?? null,
      });
   }

   displayWith(dateRangeField: string): string {
      return dateRangeField;
   }

   private initializeContentFormValue(relativeDate?: null): void {
      if (relativeDate == null) {
         return;
      }
      const optionId = relativeDate;
      // const dateRangePickerOption = this.dateRangePickerOptions.find((option) => {
      //    return option.id === optionId;
      // });

      // if (dateRangePickerOption) {
      //    const dateRange = dateRangePickerOption.callback();

      //    this.form.patchValue({
      //       endDate: dateRange.endDate,
      //       startDate: dateRange.startDate,
      //    });

      //    this.contentFormValue = {
      //       datePickerOption: dateRangePickerOption,
      //       dateRange,
      //    };
      // }
   }
}
